/**
 * Magio PDP — sticky bottom add-to-cart bar.
 */
(function () {
  function initStickyBar(root) {
    if (!root || root.dataset.magioStickyInit === 'true') return;
    root.dataset.magioStickyInit = 'true';

    var sectionId = root.dataset.sectionId;
    var productInfo = document.querySelector('product-info[data-section="' + sectionId + '"]');
    if (!productInfo) return;

    var atcAnchor = productInfo.querySelector('.magio-pdp__atc');
    if (!atcAnchor) return;

    var submitBtn = root.querySelector('[data-magio-sticky-submit]');
    var submitLabel = root.querySelector('[data-magio-sticky-submit-label]');
    var priceEl = root.querySelector('[data-magio-sticky-price]');
    var thumbEl = root.querySelector('[data-magio-sticky-thumb]');
    var mainSubmit = document.getElementById('ProductSubmitButton-' + sectionId);

    function setVisible(show) {
      root.classList.toggle('is-visible', show);
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function syncSubmitFromMain() {
      if (!mainSubmit || !submitBtn || !submitLabel) return;
      submitBtn.disabled = mainSubmit.disabled;
      var label = mainSubmit.querySelector('span');
      if (label) submitLabel.textContent = label.textContent.trim();
    }

    function syncPriceFromMain() {
      if (!priceEl) return;
      var mainPrice = productInfo.querySelector('#price-' + sectionId);
      if (mainPrice) priceEl.innerHTML = mainPrice.innerHTML;
    }

    function syncThumbFromVariant(variant) {
      if (!thumbEl || !variant) return;
      var src = null;
      if (variant.featured_image && variant.featured_image.src) {
        src = variant.featured_image.src;
      } else if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        src = variant.featured_media.preview_image.src;
      }
      if (!src) return;

      var img = thumbEl.querySelector('img');
      if (img) {
        img.src = src;
        img.srcset = '';
      } else {
        thumbEl.innerHTML =
          '<img src="' +
          src +
          '" alt="" class="magio-pdp-sticky__thumb-img" width="60" height="60" loading="lazy">';
      }
    }

    function syncFromVariantChange(event) {
      if (!event || !event.data || String(event.data.sectionId) !== String(sectionId)) return;

      var html = event.data.html;
      if (html && priceEl) {
        var priceSource = html.getElementById('price-' + sectionId);
        if (priceSource) priceEl.innerHTML = priceSource.innerHTML;
      } else {
        syncPriceFromMain();
      }

      syncThumbFromVariant(event.data.variant);
      mainSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
      syncSubmitFromMain();
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        mainSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
        if (mainSubmit && !mainSubmit.disabled) {
          mainSubmit.click();
          return;
        }
        var form = document.getElementById(root.dataset.productFormId);
        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else if (form) {
          form.submit();
        }
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, syncFromVariantChange);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { root: null, threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );

    observer.observe(atcAnchor);

    document.body.classList.add('magio-pdp-has-sticky-bar');
    syncPriceFromMain();
    syncSubmitFromMain();
  }

  function boot() {
    document.querySelectorAll('[data-magio-pdp-sticky]').forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sticky = event.target.querySelector('[data-magio-pdp-sticky]');
    if (sticky) initStickyBar(sticky);
  });
})();
